import { jsx as _jsx } from "react/jsx-runtime";
import RcTabs from 'rc-tabs';
import * as TabBar from 'rc-tabs/lib/ScrollableInkTabBar';
import * as TabContent from 'rc-tabs/lib/TabContent';
import { StyleTabs } from './styles';
import { TabPane } from '../TabPane';
import 'rc-tabs/assets/index.css';
export var Tabs = function (_a) {
  var children = _a.children,
    _b = _a.defaultActiveKey,
    defaultActiveKey = _b === void 0 ? '1' : _b,
    _c = _a.destroyInactiveTabPane,
    destroyInactiveTabPane = _c === void 0 ? false : _c,
    _d = _a.stretch,
    stretch = _d === void 0 ? false : _d,
    onChange = _a.onChange;
  return _jsx(StyleTabs, {
    stretch: stretch,
    "data-cy-label": "card-container",
    children: _jsx(RcTabs, {
      defaultActiveKey: defaultActiveKey,
      destroyInactiveTabPane: destroyInactiveTabPane,
      onChange: onChange,
      renderTabBar: function () {
        return _jsx(TabBar, {
          pageSize: 2,
          speed: 10
        });
      },
      renderTabContent: function () {
        return _jsx(TabContent, {
          animated: false,
          animatedWithMargin: false
        });
      },
      children: children
    })
  });
};
Tabs.TabPane = TabPane;